import WordCloud from 'wordcloud'
Vue.component("word_cloud_panel", {
  props: {
    player: {
      default: null
    },
  },
  data() {
    return {
    }
  },
  methods: {
    async init(contentIds) {
      contentIds = contentIds.map(el => el.contentId)
      if (!contentIds.length && WordCloud?.isSupported) return this.$emit('hasdata', false)
      //获取词云数据
      API.reqWordCloud({
        isSysAuth: false,
        contentId: contentIds[0]
      }).then(res => {
        if (res.success && res.data.length) {
          this.$emit('hasdata', true)
          let words = res.data.map(el => [el.name, el.value])
          WordCloud(this.$refs.word_cloud_content, {
            list: words,
            // gridSize: 10,
            weightFactor: 10,
            // color: 'random-dark',
            backgroundColor: '#fff',
            // shrinkToFit: true,
            // minSize: 6,
            shape: (theta) => {
              const a = 1; // 水平半径（宽度）
              const b = 2; // 垂直半径（高度，是宽度的 2 倍）
              return (a * b) / Math.sqrt((b * Math.cos(theta)) ** 2 + (a * Math.sin(theta)) ** 2);
            },
          })
        } else {
          this.$emit('hasdata', false)
        }
      }).catch(() => {
        this.$emit('hasdata', false)
      })
    },
  },
  template: `
  <div ref="word_cloud_content" class="word_cloud_panel" style="width: 100%;height: 100%;"></div>
  `,
});